import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsEightsleepComponent } from './simple-icons-eightsleep.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsEightsleepComponent ],
    exports:      [ SimpleIconsEightsleepComponent ],
    bootstrap:    []
})
export class SimpleIconsEightsleepModule {}
